<template>
  <div class="basic-block block-hero-base" :style="styles">
    <div class="content-wrap">
      <picture>
        <source v-if="targetInfo.hero.sp" :srcset="targetInfo.hero.sp" media="(max-width:580px)">
        <source v-if="targetInfo.hero.pc" :srcset="targetInfo.hero.pc">
        <img :src="fallbackPath" :alt="targetInfo.hero.alt" class="block-hero-base__hero">
      </picture>
      <div class="block-hero-base__lead">的中連発で芸能人も驚愕！<br>あなたの本質と未来を占います</div>
      <lp-base-button label="今すぐ鑑定する" design="fill" :color-scheme="colorScheme" @clicked="clicked" />
      <lead-login :color-scheme="colorScheme" />
    </div>
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'
import LeadLogin from '@/utvStore/components/recommend/lp/partials/LeadLogin'

export default {
  name: 'BlockHero',
  components: {
    LpBaseButton,
    LeadLogin,
  },
  props: {
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    subscUrl: {
      type: String,
      require: true
    },
    lpId: Number,
  },
  computed:{
    fallbackPath(){
      const dt = this.targetInfo.hero
      return window.innerWidth > 580
        ? (!!dt.fallback_pc ? dt.fallback_pc : dt.pc)
        : (!!dt.fallback_pc ? dt.fallback_sp : dt.sp)
    },
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
  methods: {
    clicked(e) {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}-subsc-button`,
        'event_label': `0729-1`
      })
      location.href = this.$handoverParams(this.subscUrl)
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-hero-base {
  padding: 0 0 95px;
  background: 
    url('/static/img/recommend/lp/kanoucoco/deco_wave.png') no-repeat 50% calc(100% + 56px)/100% 112px;
  background-color: #FFECEB;
  &__hero {
    display: block;
    width: 100%;
    // max-width: 500px;
    margin: auto;
  }
  &__lead {
    font-weight: 600;
    font-size: 20px;
    line-height: 2;
    text-align: center;
    color: $l_col_keycolor;
    margin: 40px 0 35px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/kanoucoco/blocks/BlockHero.vue